import { PaletteMode, PaletteOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import { unitySemanticDarkColorTokens, unitySemanticLightColorTokens } from '../unityTokens';
import { buildPaletteFromMetadata, type Token } from './panw-palette/token-metadata';

const interactiveTokens = [
  { propertyPath: 'neutral.default', tokenName: '--semantic-bg-interactive-neutral-default' },
  { propertyPath: 'neutral.hover', tokenName: '--semantic-bg-interactive-neutral-hover' },
  { propertyPath: 'neutral.active', tokenName: '--semantic-bg-interactive-neutral-active' },
  { propertyPath: 'neutral.disabled', tokenName: '--semantic-bg-interactive-neutral-disabled' },
  { propertyPath: 'neutral.focus', tokenName: '--semantic-bg-interactive-neutral-focus' },
  { propertyPath: 'highlight.default', tokenName: '--semantic-bg-interactive-highlight-default' },
  { propertyPath: 'highlight.hover', tokenName: '--semantic-bg-interactive-highlight-hover' },
] satisfies Token[];

export const interactive = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['interactive'] => {
  if (opts.panwRebrandStubYear) {
    const tokens = mode === 'light' ? unitySemanticLightColorTokens : unitySemanticDarkColorTokens;
    return buildPaletteFromMetadata(interactiveTokens, tokens);
  }

  // we shouldn't hit this as the code path is gated, setting everything to red
  // so that we can see if something is wrong
  return {
    neutral: {
      default: '#FF0000',
      hover: '#FF0000',
      active: '#FF0000',
      disabled: '#FF0000',
      focus: '#FF0000',
    },
    highlight: {
      default: '#FF0000',
      hover: '#FF0000',
    },
  };
};
